module.exports = __webpack_public_path__ + "static/media/dripping.7c8ec41b.png";